import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDuaez1f6-mjN7aa9R2pL9VS-pk8hj8Dtw",
    authDomain: "instagram-clone-project-4d840.firebaseapp.com",
    projectId: "instagram-clone-project-4d840",
    storageBucket: "instagram-clone-project-4d840.appspot.com",
    messagingSenderId: "109657592633",
    appId: "1:109657592633:web:1b23fe6d94facfce698ee8",
    measurementId: "G-6ZHHBJXRFF"
});

const db = firebaseApp.firestore();
const auth = firebase.auth();
const storage = firebase.storage();


export { db, auth, storage };